import { sharedApi, getAuthToken } from "./sharedApi";

import type {
  AdaptiveQuestionResponse,
  AdaptiveResultResponse,
  AdaptiveStudyMode,
  AnswerQuality,
} from "../types/adaptive";

export const adaptiveStudyAPI = {
  async getQuestion(
    _params: { forceLearning?: boolean } = {},
  ): Promise<AdaptiveQuestionResponse> {
    const token = getAuthToken();
    // Backend chooses optimal mode if not provided; we pass only forceLearning for now
    const response = await sharedApi.dictionary.getAdaptiveQuestion(
      { forceLearning: Boolean(_params.forceLearning) },
      token,
    );
    return response as unknown as AdaptiveQuestionResponse;
  },

  async submitResult(_data: {
    wordId: string;
    mode: AdaptiveStudyMode;
    isCorrect: boolean;
    answerQuality: AnswerQuality;
    responseTime: number;
    hintsUsed: number;
  }): Promise<AdaptiveResultResponse> {
    const token = getAuthToken();
    const response = await sharedApi.dictionary.submitAdaptiveResult(
      {
        wordId: _data.wordId,
        mode: _data.mode,
        isCorrect: _data.isCorrect,
        answerQuality: _data.answerQuality,
        responseTime: _data.responseTime,
        hintsUsed: _data.hintsUsed,
      },
      token,
    );
    return response as unknown as AdaptiveResultResponse;
  },

  async getStats(days: number = 30) {
    const token = getAuthToken();
    return await sharedApi.features.getAdaptiveStudyStats(days, token);
  },
};
